import { AssetWallet } from "../../interfaces/asset_wallet";
import { TYPE_NAME_METAL } from "@helpers/constants";

export class MetalWallet extends AssetWallet {
	public static TypeName = TYPE_NAME_METAL;
}
